var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileIconPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "icon file",
    viewBox: "0 0 32 32.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.309 32a4.347 4.347 0 0 1-4.307-4.379V4.377A4.345 4.345 0 0 1 9.309 0h9.7l7.99 8.971v18.65A4.347 4.347 0 0 1 22.688 32zM6.934 4.377v23.244a2.4 2.4 0 0 0 2.375 2.406h13.379a2.4 2.4 0 0 0 2.381-2.406V11.5h-4.42A4.51 4.51 0 0 1 16.143 7V1.967H9.309a2.4 2.4 0 0 0-2.375 2.412zm11.217 2.617a2.614 2.614 0 0 0 2.5 2.5h4.148l-6.643-7.457z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIconPlaceholder);
export default __webpack_public_path__ + "static/media/file-icon-placeholder.8b3a27830d3e8015b754f53b71ddab1c.svg";
export { ForwardRef as ReactComponent };